<template>
  <section class="login-wrapper">
    <section class="material-half-bg">
      <div class="cover"></div>
    </section>
    <section class="container mt-4">
      <h2 class="text-center">
        ตารางทำความสะอาดห้องน้ำ
        <b class="text-danger-emphasis">บันทึกการทำความสะอาดห้องน้ำ</b>
      </h2>
      <h3 class="text-center mb-4">#{{ code }}</h3>

      <div class="text-center">
        <button
          class="btn btn-warning border-dark btn-lg mb-3"
          @click="openFormModal"
        >
          เพิ่มบันทึกการทำความสะอาด
        </button>
      </div>

      <div class="card mb-3">
        <div class="card-body">
          <form class="d-md-inline-block form-inline ms-auto me-0 me-md-3 mb-3">
            <div class="input-group">
              <select v-model="selectedMonth" class="form-select" required>
                <option value="" disabled>- เลือกเดือน -</option>
                <option
                  v-for="month in months"
                  :key="month.value"
                  :value="month.value"
                >
                  {{ month.name }}
                </option>
              </select>
              <select v-model="selectedYear" class="form-select ms-2" required>
                <option value="" disabled>- เลือกปี -</option>
                <option v-for="year in years" :key="year" :value="year">
                  {{ year + 543 }}
                </option>
              </select>
              <button
                @click.prevent="clearFilters"
                class="btn btn-secondary"
                type="button"
              >
                <i class="bi bi-arrow-clockwise"></i> รีเซ็ต
              </button>
            </div>
          </form>

          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="table-dark text-center">
                <tr>
                  <th>วันเวลาที่บันทึก</th>
                  <th>ชื่อผู้บันทึก</th>
                  <th>รหัส-ชื่อ</th>
                  <th v-for="name in cleaningItemNames" :key="name">
                    {{ name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!cleaningRecords.length">
                  <td
                    class="text-center text-muted"
                    colspan="3 + cleaningItemNames.length"
                  >
                    ไม่มีข้อมูล
                  </td>
                </tr>

                <tr v-for="record in cleaningRecords" :key="record.id">
                  <td>
                    {{ formatDateTimeUTC(record.record_date) }} |
                    {{ record.record_time }}
                  </td>
                  <td>{{ record.recorder }}</td>
                  <td>
                    {{ record.restroom.code }} - {{ record.restroom.name }}
                  </td>
                  <td v-for="name in cleaningItemNames" :key="name">
                    <template v-if="(item = getItem(record, name))">
                      <span
                        :class="
                          item.pivot.status ? 'text-success' : 'text-danger'
                        "
                      >
                        {{ item.pivot.status ? "✅" : "❌" }}
                      </span>
                    </template>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
            <h4 class="text-center">ตารางสรุปรายวันแบบปฏิทิน</h4>
            <div class="table-responsive">
              <table class="table table-bordered text-center">
                <thead class="table-dark">
                  <tr>
                    <th>รายการทำความสะอาด</th>
                    <th v-for="day in daysInMonth" :key="day">{{ day }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="itemName in cleaningItemNames" :key="itemName">
                    <th class="text-start">{{ itemName }}</th>
                    <td v-for="day in daysInMonth" :key="day">
                      <span
                        v-if="
                          recordsByDayItem[itemName] &&
                          recordsByDayItem[itemName][day] === 1
                        "
                        class="text-success"
                        >✅</span
                      >
                      <span
                        v-else-if="
                          recordsByDayItem[itemName] &&
                          recordsByDayItem[itemName][day] === 0
                        "
                        class="text-danger"
                        >❌</span
                      >
                      <span v-else>-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal for inserting form data -->
      <div
        class="modal fade"
        id="myModal"
        tabindex="-1"
        data-bs-backdrop="static"
        aria-labelledby="roleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">บันทึกการทำความสะอาดห้องน้ำ</h5>
              <button
                type="button"
                class="btn-close"
                @click="closeFormModal"
              ></button>
            </div>
            <div class="modal-body">
              <!-- Form content will be added here -->
              <form @submit.prevent="submitForm">
                <!-- <div class="row" hidden> -->
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label"
                        >วันที่บันทึก (Record Date)</label
                      >
                      <DatePicker v-model="date" />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label">เวลา (Record Time)</label>
                      <TimePicker v-model="time" required />
                    </div>
                  </div>
                </div>

                <!-- Department -->
                <div class="mb-3">
                  <label class="form-label">หน่วยงาน (Department)</label>
                  <select
                    disabled
                    class="form-select"
                    v-model="groupId"
                    required
                  >
                    <option value="" disabled>Select a department</option>
                    <option
                      v-for="dept in groups"
                      :key="dept.id"
                      :value="dept.id"
                    >
                      {{ dept.name }}
                    </option>
                  </select>
                </div>

                <!-- Restroom -->
                <div class="mb-3">
                  <label class="form-label">ห้องน้ำ (Restroom)</label>
                  <select
                    disabled
                    class="form-select"
                    v-model="restroomId"
                    required
                  >
                    <option value="" disabled>Select a restroom</option>
                    <option
                      v-for="restroom in restrooms"
                      :key="restroom.id"
                      :value="restroom.id"
                    >
                      {{ restroom.code }} - {{ restroom.name }}
                    </option>
                  </select>
                </div>

                <!-- Cleaning Items -->
                <div class="mb-3">
                  <label class="form-label"
                    >รายการทำความสะอาด (Cleaning Items)</label
                  >
                  <div
                    v-for="item in cleaningItems"
                    :key="item.id"
                    class="form-check"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="item.id"
                      v-model="item.status"
                    />
                    <label :for="item.id" class="form-check-label">
                      {{ item.name }}
                    </label>
                  </div>
                </div>
                <!-- Recorder Name -->
                <div class="mb-3">
                  <label class="form-label">ชื่อผู้บันทึก (Recorder)</label>
                  <v-select
                    v-model="recorder"
                    :options="doctors"
                    label="name"
                    :reduce="(item) => item.name"
                    :clearable="false"
                    placeholder="ค้นหา..ชื่อผู้บันทึก"
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!recorder"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                </div>

                <hr />
                <button type="submit" class="btn btn-lg btn-primary w-100">
                  บันทึกข้อมูล (Save)
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from "vue";
// import { formatDateTime } from '@/utils/dateUtils';
import { Modal } from "bootstrap";
import { showErrorAlert, showSuccessAlert } from "@/utils/sweetalert2-utils";
import axiosInstance from "@/utils/axiosInstance";
import axios from "axios";
import { useRoute } from "vue-router";
import { computed } from "vue";
import Swal from "sweetalert2";
import moment from "moment";
// import TimeMaskedInput from '@/components/TimeMaskedInput.vue';
import DatePicker from "@/components/DatePicker.vue";
import TimePicker from "@/components/TimePicker.vue";

const now = moment().format("YYYY-MM-DD HH:mm:ss");
const [dateStr, timeStr] = now.split(" ");

const date = ref(dateStr);
const time = ref(timeStr);

const modal = ref(null);
const cleaningRecords = ref([]);
const cleaningItemNames = ref([]);

const recorder = ref("");
const groupId = ref(null);
const restroomId = ref(null);
const cleaningItems = ref([]);
const groups = ref([]);
const restrooms = ref([]);
const doctors = ref([]);
const route = useRoute();
const code = ref(route.params.code);

const today = new Date();
const selectedMonth = ref(today.getMonth() + 1);
const selectedYear = ref(today.getFullYear());

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 3 }, (_, i) => currentYear - i); // 5 ปีย้อนหลัง

const getItem = (record, name) => {
  return record.cleaning_items.find((i) => i.name === name);
};

function clearFilters() {
  const now = new Date();
  selectedMonth.value = now.getMonth() + 1;
  selectedYear.value = now.getFullYear();
  // ข้อมูลจะถูกดึงใหม่เองผ่าน watch ที่เราเขียนไว้ข้างบน
}

const daysInMonth = computed(() => {
  const numDays = new Date(
    selectedYear.value,
    selectedMonth.value,
    0
  ).getDate();
  return Array.from({ length: numDays }, (_, i) => i + 1);
});

const recordsByDayItem = computed(() => {
  const map = {};

  cleaningRecords.value.forEach((record) => {
    const day = moment(record.record_date, "YYYY-MM-DD").date();

    record.cleaning_items.forEach((item) => {
      const itemName = item.name;
      if (!map[itemName]) {
        map[itemName] = {};
      }
      map[itemName][day] = item.pivot.status ? 1 : 0;
    });
  });

  return map;
});

const months = [
  { value: 1, name: "มกราคม" },
  { value: 2, name: "กุมภาพันธ์" },
  { value: 3, name: "มีนาคม" },
  { value: 4, name: "เมษายน" },
  { value: 5, name: "พฤษภาคม" },
  { value: 6, name: "มิถุนายน" },
  { value: 7, name: "กรกฎาคม" },
  { value: 8, name: "สิงหาคม" },
  { value: 9, name: "กันยายน" },
  { value: 10, name: "ตุลาคม" },
  { value: 11, name: "พฤศจิกายน" },
  { value: 12, name: "ธันวาคม" },
];

function formatDateTimeUTC(dateStr) {
  const m = moment.utc(dateStr).locale("th");
  const buddhistYear = m.year() + 543;
  const month = m.format("MMM");
  const day = m.format("D");
  return `${day} ${month} ${String(buddhistYear).slice(2)}`; // ได้รูปแบบ '4 มิ.ย. 68'
}
const getDoctors = async () => {
  try {
    const res = await axios.get(
      "https://api-hos.wanorn.com/backend/api/doctor"
    );
    // doctors.value = res.data;
    doctors.value = res.data.filter((doctor) => doctor.active !== "N");
  } catch (error) {
    showErrorAlert("ไม่สามารถโหลดข้อมูลได้");
  }
};

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

const loading = ref(true);

const fetchCleaningRecords = async () => {
  loading.value = true;
  try {
    // ส่ง params ไปกับ request เพื่อให้ Backend กรองข้อมูลให้
    const response = await axiosInstance.get(`/cleaning_record/`, {
      params: {
        month: selectedMonth.value,
        year: selectedYear.value,
        restroom_id: restroomId.value,
      },
    });

    cleaningRecords.value = response.data;

    // ดึงชื่อรายการทำความสะอาด (คงเดิม)
    const allItems = new Set();
    cleaningRecords.value.forEach((record) => {
      record.cleaning_items.forEach((item) => {
        allItems.add(item.name);
      });
    });
    cleaningItemNames.value = Array.from(allItems);

    // ตรวจสอบการบันทึกของวันนี้ (แจ้งเตือนผู้ใช้)
    const currentDate = moment().format("YYYY-MM-DD");
    const todayRecord = cleaningRecords.value.find((record) => {
      return moment(record.record_date).format("YYYY-MM-DD") === currentDate;
    });

    Toast.fire({
      icon: todayRecord ? "success" : "warning",
      title: todayRecord ? "บันทึกแล้วในวันนี้" : "วันนี้ยังไม่ได้บันทึก",
    });
  } catch (error) {
    console.error("Error fetching cleaning records:", error);
    showErrorAlert("ไม่สามารถโหลดข้อมูลได้");
  } finally {
    loading.value = false;
  }
};

const fetchDataCode = async () => {
  try {
    const response = await axiosInstance.get(`/check_restroom/${code.value}`);
    restroomId.value = response.data.id;
    groupId.value = response.data.group_id;
    fetchCleaningRecords(response.data.id);
  } catch (error) {
    showErrorAlert("ไม่สามารถโหลดข้อมูลได้");
  }
};

// Show the modal
const showModal = () => {
  if (modal.value) {
    modal.value.show(); // Show the modal
  }
};

// Hide the modal
const hideModal = () => {
  if (modal.value) {
    modal.value.hide(); // Hide the modal
  }
};

const openFormModal = () => showModal();
const closeFormModal = () => {
  hideModal();
};

// Handle form submission
const submitForm = async () => {
  try {
    // Prepare payload for the API request
    const payload = {
      recorder: recorder.value,
      group_id: groupId.value,
      restroom_id: restroomId.value,
      record_date: date.value,
      record_time: moment(time.value, "HH:mm").format("HH:mm:ss"),
      cleaning_items: cleaningItems.value.map((item) => ({
        id: item.id,
        status: item.status ? 1 : 0, // Convert boolean to 1 (checked) or 0 (unchecked)
      })),
    };

    // Send POST request to the API
    const response = await axiosInstance.post("/cleaning_record", payload);
    console.log(response);
    showSuccessAlert();
    fetchDataCode();
    hideModal();
    // Display success alert
    // Swal.fire({
    //     icon: "success",
    //     title: "Success!",
    //     text: "Cleaning record added successfully!",
    // });

    // Reset form after submission
    resetForm();
  } catch (error) {
    // Display error alert if submission fails
    // Swal.fire({
    //     icon: "error",
    //     title: "Error!",
    //     text: "Failed to submit the record.",
    // });
    showErrorAlert();
    hideModal();
    console.error("Submission error:", error);
  }
};

// Reset form fields
const resetForm = () => {
  recorder.value = "";
  cleaningItems.value = cleaningItems.value.map((item) => ({
    id: item.id,
    name: item.name,
    status: false,
  }));
};

watch([selectedMonth, selectedYear], () => {
  if (restroomId.value) {
    fetchCleaningRecords(restroomId.value);
  }
});

onMounted(async () => {
  try {
    const [deptRes, restroomRes, cleaningRes] = await Promise.all([
      axiosInstance.get("/group"), // Fetch departments
      axiosInstance.get("/restroom"), // Fetch restrooms
      axiosInstance.get("/cleaning_item"), // Fetch cleaning items
    ]);

    groups.value = deptRes.data;
    restrooms.value = restroomRes.data;
    cleaningItems.value = cleaningRes.data.map((item) => ({
      id: item.id,
      name: item.name,
      status: false, // Initially, all cleaning items are not checked
    }));

    fetchDataCode();
    getDoctors();
  } catch (error) {
    showErrorAlert("ไม่สามารถโหลดข้อมูลได้");
  } finally {
    // Initialize the modal after the component is mounted
    const modalElement = document.getElementById("myModal");
    modal.value = new Modal(modalElement); // Create a new Modal instance
  }
});

onUnmounted(() => {
  modal.value?.dispose();
});
</script>

<style scoped>
.login-wrapper {
  display: flex;
  height: 100vh;
}

.material-half-bg {
  flex: 1;
}

.login-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cover {
  background: url("https://www.jorakay.co.th/imgadmins/source/blog/bathroom-cleaning-tips/01_bathroom-cleaning-tips.webp?1722585348214")
    no-repeat center center;
  background-size: cover;
  height: 100%;
  opacity: 0.3;
  /* Adjust opacity value as needed */
}
</style>
